import axios from 'axios';
import { BASE_URL} from '../utils/constants';

export const SvcPostPublic = (endpoint,payload) => {
  return axios(BASE_URL+endpoint, {
    method: 'POST',
    data: payload
  })
    .then(response => response)
    .catch(error => {
      throw error;
    });
};


export const SvcPostPrivate = (endpoint, payload) => {
  const token = localStorage.getItem('accessToken');
  return axios(BASE_URL + endpoint, {
    method: 'POST',
    data: payload,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(response => response)
    .catch(error => {
      throw error;
    });
};

export const SvcPutPrivate = (endpoint, payload) => {
  const token = localStorage.getItem("accessToken");
  return axios(BASE_URL + endpoint, {
    method: "PUT",
    data: payload,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response)
    .catch((error) => {
      throw error;
    });
};

export const SvcGetPrivate = (endpoint, params = {}) => {
  const token = localStorage.getItem('accessToken');
  return axios.get(BASE_URL + endpoint, {
    params: params,   // <-- yehi querystring banata hai
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(response => response)
    .catch(error => { throw error; });
};

export const SvcPostPrivateBlob = (endpoint, payload) => {
  const token = localStorage.getItem('accessToken');
  return axios(BASE_URL + endpoint, {
    method: 'POST',
    data: payload,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    responseType: 'blob'   // 👈 yeh important hai
  })
    .then(response => response)
    .catch(error => { throw error; });
};





export const setSession = payload => {
  localStorage.setItem('accessToken', payload.token);
localStorage.setItem('_id', payload._id);
};